<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-container>
              <v-row align="center" style="min-height:80px;">
                <v-col cols="11">
                  <v-select v-if="showSelectHeaders"
                            label="Campos da tabela"
                            item-title="title"
                            return-object
                            :items="headers"
                            hide-details
                            multiple
                            clearable
                            chips
                            v-model="selectedHeaders"
                            @update:modelValue="saveSelectedHeaders"></v-select>
                  <DialogCreateUpdatePaymentMethod v-else
                                                   :user="user"
                                                   v-model="editPaymentMethodModel"
                                                   :floatRight="true"
                                                   :hideButton="false"
                                                   @created="createdPaymentMethod"
                                                   @updated="updatedPaymentMethod" />
                </v-col>
                <v-col cols="1" class="txt-right">
                  <v-tooltip location="top">
                    <template v-slot:activator="{ props }">
                      <v-btn icon density="compact"
                             v-bind="props"
                             variant="text">
                        <v-icon color="grey-lighten-1"
                                @click="showSelectHeaders = !showSelectHeaders">
                          mdi-cog
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Configurar Cabeçalhos</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-data-table
                        :headers="selectedHeaders"
                        :items="lstObjects"
                        :search="searchFilter"
                        :items-per-page="filters.itemsPerPage"
                        return-object
                        class="elevation-1"
                        hide-default-footer>
            <template v-slot:bottom>
              <div class="text-center pt-2">
                <v-pagination
                              :disabled="requestingApi"
                              v-model="page"
                              :length="maxPage"></v-pagination>
              </div>
            </template>
            <template v-slot:item.type="{ value }">
              <span>{{
                $PAYMENT_METHOD_TYPES_DIC[value]
                ? $PAYMENT_METHOD_TYPES_DIC[value].label
                : value
              }}</span>
            </template>
            <template v-slot:item.allow_online_payment="{ value }">
              <span>{{
                value ? "SIM" : "NÃO"
              }}</span>
            </template>
            <template v-slot:item.minimum_due_amount="{ value }">
              <span>{{
                $filters.currency(value || 0, 'BRL')
              }}</span>
            </template>
            <template v-slot:item.enabled="{ value }">
              <span>{{
                value ? "SIM" : "NÃO"
              }}</span>
            </template>
            <template v-slot:item.created_at="{ value }">
              <span>{{
                $moment(value).local().format("DD/MM/YYYY hh:mm:ss")
              }}</span>
            </template>
            <template v-slot:item.updated_at="{ value }">
              <span>{{
                $moment(value).local().format("DD/MM/YYYY hh:mm:ss")
              }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu>
                <template v-slot:activator="{ props }">
                  <v-btn icon variant="text" v-bind="props"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                </template>
                <v-list>
                  <v-list-item @click="editPaymentMethodModel = item">
                    <v-list-item-title>
                      <v-icon color="primary" class="mr-2">mdi-pencil</v-icon>
                      Editar
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="deletePaymentMethod(item)">
                    <v-list-item-title>
                      <v-icon color="red" class="mr-2">mdi-trash-can</v-icon>
                      Excluir
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DialogCreateUpdatePaymentMethod from '../components/DialogCreateUpdatePaymentMethod.vue';
import api from '@/services'
export default {
  components: { DialogCreateUpdatePaymentMethod },
  props: {
    user: Object
  },
  data() {
    return {
      requestingApi: false,
      tab: 1,
      headers: [
        { title: "ID", align: "start", key: "id", sortable: true },
        { title: "Nome", align: "start", key: "name", sortable: true },
        { title: "Online", align: "start", key: "allow_online_payment", sortable: true },
        { title: "Tipo", align: "start", key: "type", sortable: true },
        { title: "Habilitado", align: "start", key: "enabled", sortable: true },
        { title: "Valor Mínimo", align: "start", key: "minimum_due_amount", sortable: true },
        { title: "Taxa GGrupos", align: "start", key: "tax_1", sortable: true },
        // { title: "Taxa 2", align: "start", key: "tax_2", sortable: true },
        { title: "Taxa Método", align: "start", key: "tax_3", sortable: true },
        { title: "Taxa Mínima  Método", align: "start", key: "tax_4", sortable: true },
        // { title: "Taxa 5", align: "start", key: "tax_5", sortable: true },
        { title: "Prazo para Pagamento", align: "start", key: "payment_delay", sortable: true },
        { title: "Criação", align: "start", key: "created_at", sortable: true },
        { title: "Última Atualização", align: "start", key: "updated_at", sortable: true },
        { title: "Ações", key: "actions", align: "end", sortable: false },
      ],
      selectedHeaders: [],
      showSelectHeaders: false,
      lstObjects: [],
      filters: {
        withUser: true,
        special_filters: [],
        itemsPerPage: 1,
        is_human: null,
        type: null,
        group_id: null,
      },
      editPaymentMethodModel: {},
      dialogCreateEdit: false,
      searchFilter: null,
      page: 1,
      maxPage: 1,
    };
  },
  created() {
    var vm = this;
    vm.loadParameters();
  },
  mounted() { },
  activated() {
    this.submitSearch(this.page);
  },
  methods: {
    saveSelectedHeaders() {
      var vm = this;
      try {
        localStorage.setItem(
          "_payment_method_list_headers",
          JSON.stringify(vm.selectedHeaders)
        );
      } catch (error) {
        console.error(error);
      }
    },
    selectedGroup(group) {
      var vm = this;
      vm.filters.group_id = group?.id;
    },
    loadParameters() {
      var vm = this;
      let _itemsPerPage = localStorage["_payment_method_itemsPerPage"];
      vm.filters.itemsPerPage = parseInt(_itemsPerPage || 10);

      try {
        let _headers = localStorage["_payment_method_list_headers"];
        vm.selectedHeaders = _headers ? JSON.parse(_headers) : vm.headers;
      } catch (error) {
        vm.selectedHeaders = vm.headers;
      }
    },
    clearFilters() {
      var vm = this;
      vm.filters.searchText = null;
      vm.searchFilter = null;
      vm.filters.special_filters = [];
    },
    submitSearch(page) {
      var vm = this;
      if (!vm.requestingApi) {
        vm.requestingApi = true;
        vm.page = page || 1;
        return new Promise((resolve, reject) => {
          api.paymentMethod
            .list(vm.filters, page || 1)
            .then((result) => {
              vm.lstObjects = result?.data;
              vm.maxPage = Math.ceil(
                (result?.total || 1) / (result?.per_page || 10)
              );
              vm.$notify({
                type: "success",
                text: "Pesquisa concluída",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    deletePaymentMethod(paymentMethod) {
      const vm = this;

      if (!vm.requestingApi) {
        vm.requestingApi = true;
        return new Promise((resolve, reject) => {
          api.paymentMethod
            .delete(paymentMethod.id)
            .then((result) => {
              vm.lstObjects = vm.lstObjects.filter(o => o.id !== paymentMethod.id);
              vm.$notify({
                type: "success",
                text: "Método de pagamento excluído",
              });
            })
            .catch((err) => {
              if (err.message) {
                vm.$notify({
                  type: "warn",
                  text: err.message,
                });
              }
            })
            .finally(() => {
              vm.requestingApi = false;
            });
        });
      }
    },
    createdPaymentMethod(val) {
      const vm = this;

      vm.editPaymentMethodModel = {};
      vm.lstObjects.push(val);
      vm.lstObjects = vm.listObjects.slice(0);
    },
    updatedPaymentMethod(val) {
      const vm = this;

      vm.editPaymentMethodModel = {};
      vm.lstObjects = vm.lstObjects.map(o => (o.id === val.id ? val : o));
    },
  },
  computed: {},
  watch: {
    "filters.itemsPerPage"(newVal) {
      localStorage["_payment_method_itemsPerPage"] = newVal;
    },
    page(newVal) {
      var vm = this;
      if (!isNaN(newVal)) {
        vm.submitSearch(newVal);
      }
    },
  },
};
</script>